<div class="page-header">
  @if(!isMobile) {
    <h1 class="page-title">Saved Trucks</h1>
  } @else {
    <div class="results-count">
      @if (loading) {
        <mat-spinner diameter="20"></mat-spinner>
      } @else {
        Results: 
        <span class="ml-3" [class.no-results]="results.data.length === 0">
          {{ results.data.length }}
        </span>
      }
    </div>
  }

  <div class="header-actions">

    @if(!isMobile) {
      <div class="results-count">
        @if (loading) {
          <mat-spinner diameter="20"></mat-spinner>
        } @else {
          Results: 
          <span class="ml-3" [class.no-results]="results.data.length === 0">
            {{ results.data.length }}
          </span>
        }
      </div>
    }

    <button mat-icon-button class="refresh-button" (click)="getSavedTrucks(true)" matTooltip="Refresh" [disabled]="loading">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>
</div>

<table mat-table [dataSource]="results" matSort class="results-table">

  <!-- Mobile Column -->
  <ng-container matColumnDef="mobile">
    <th mat-header-cell *matHeaderCellDef></th>

    <td mat-cell *matCellDef="let truck">
      <div class="mobile-load-cell">

        @if ((!truck.deleted_at && truck.visible) || truck.is_saved) {
          <button
            mat-icon-button
            class="mobile-save-button"
            (click)="toggleSavedTruck(truck); $event.stopPropagation()"
          >
            <mat-icon [class.saved]="truck.is_saved">
              {{ truck.is_saved ? 'favorite' : 'favorite_border' }}
            </mat-icon>
          </button>
        }

        <div class="mobile-location-row">
          <mat-icon class="mobile-map-icon">location_on</mat-icon>

          <div class="location-text">
            {{ truck.origin_city | titlecase }}, {{ truck.origin_state }}

            @if (truck.origin_deadhead_distance) {
              <span class="deadhead-distance">
                ({{ truck.origin_deadhead_distance }} mi)
              </span>
            }
          </div>
        </div>

        @if (truck.deleted_at) {
          <div class="mobile-details">
            <span class="tag red">removed</span>
          </div>
        } @else if (!truck.visible) {
          <div class="mobile-details">
            <span class="tag yellow">unposted</span>
          </div>
        } @else {
          <div class="mobile-details">
            Age: {{ formatAge(truck.refreshed_since) }}
          </div>
        }

        <div class="mobile-details">
          Available:
          @if (truck.available_start_date === truck.available_end_date) {
            {{ truck.available_start_date | date:'MM/dd' }}
          } @else {
            {{ truck.available_start_date | date:'MM/dd' }} -
            {{ truck.available_end_date | date:'MM/dd' }}
          }
        </div>

        <div class="mobile-details">
          Max Weight: {{ truck.max_weight | number }} lbs
        </div>

        <div class="mobile-details">
          Axles: {{ truck.axle_count }}
        </div>

        <div class="mobile-details">
          Well: {{ toFeetAndInches(truck.well_length) }}
        </div>

        <div class="mobile-details">
          {{ truck.carrier_name }}
        </div>

        @if (truck.carrier_base_state) {
          <div class="mobile-details">
            Base: {{ truck.carrier_base_state }}
          </div>
        }

      </div>
    </td>
  </ng-container>

  <!-- Desktop Columns -->
  <ng-container matColumnDef="is_saved">
    <th mat-header-cell *matHeaderCellDef>
    </th>
    <td mat-cell *matCellDef="let truck">

      @if ((!truck.deleted_at && truck.visible) || truck.is_saved) {
        <button
          mat-icon-button
          (click)="toggleSavedTruck(truck); $event.stopPropagation()"
        >
          <mat-icon [class.saved]="truck.is_saved">
            {{ truck.is_saved ? 'favorite' : 'favorite_border' }}
          </mat-icon>
        </button>
      }

    </td>
  </ng-container>

  <ng-container matColumnDef="age">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      Age
    </th>
    <td mat-cell *matCellDef="let truck">
      @if (truck.deleted_at) {
        <span class="tag red">removed</span>
      } @else if (!truck.visible) {
        <span class="tag yellow">unposted</span>
      } @else {
        {{ formatAge(truck.refreshed_since) }}
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="origin_city">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      Origin
    </th>
    <td mat-cell *matCellDef="let truck">
      {{ truck.origin_city }}
    </td>
  </ng-container>

  <ng-container matColumnDef="origin_state">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
    </th>
    <td mat-cell *matCellDef="let truck">
      {{ truck.origin_state }}
    </td>
  </ng-container>

  <ng-container matColumnDef="available_dates">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      Dates
    </th>
    <td mat-cell *matCellDef="let truck">
      @if(truck.available_start_date === truck.available_end_date) {
      {{ truck.available_start_date | date: 'MM/dd' }}
      } @else {
      {{ truck.available_start_date | date: 'MM/dd' }} -
      {{ truck.available_end_date | date: 'MM/dd' }}
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="max_weight">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      Max Weight
    </th>
    <td mat-cell *matCellDef="let truck">
      {{ truck.max_weight }}
    </td>
  </ng-container>

  <ng-container matColumnDef="axle_count">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      Axles
    </th>
    <td mat-cell *matCellDef="let truck">
      {{ truck.axle_count }}
    </td>
  </ng-container>

  <ng-container matColumnDef="well_length">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      Well Length
    </th>
    <td mat-cell *matCellDef="let truck">
      {{ toFeetAndInches(truck.well_length) }}
    </td>
  </ng-container>

  <ng-container matColumnDef="carrier">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      Carrier
    </th>
    <td mat-cell *matCellDef="let truck">
      {{ truck.carrier_name }}
    </td>
  </ng-container>

  <ng-container matColumnDef="carrier_base_state">
    <th mat-header-cell *matHeaderCellDef matTooltip="Carrier Home Base State" mat-sort-header>
      Base
    </th>
    <td mat-cell *matCellDef="let truck">
      {{ truck.carrier_base_state }}
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns" [hidden]="results.data.length === 0"></tr>

  <tr
    mat-row
    *matRowDef="let row; columns: displayedColumns"
    [class.inactive-row]="row.deleted_at || !row.visible"
    [class.clickable-row]="!row.deleted_at && row.visible"
    (click)="!row.deleted_at && row.visible && viewTruckDetails(row)"
  ></tr>

  <tr class="mat-row" *matNoDataRow>
    <td class="no-results-cell" [attr.colspan]="displayedColumns.length">
      <div class="yellow-container">
        You have no saved trucks.
      </div>
    </td>
  </tr>
</table>

<br />

<mat-paginator
  [style.display]="results.data.length === 0 ? 'none' : ''"
  [pageSize]="itemsPerPage"
  [pageSizeOptions]="[10, 25, 50, 100]"
  showFirstLastButtons
></mat-paginator>